var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actorpage"},[_c('div',[(_vm.actorVideos && _vm.actorVideos.length > 0)?_c('swiper-list',{attrs:{"title":`Videos featuring ${_vm.$route.params.name}`,"items":_vm.actorVideos}}):_c('p',[_vm._v("No videos found for this actor.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }